module.exports = __webpack_public_path__ + "assets/projects/robots-and-ai/content.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/robots-and-ai/content.jpg
// module id = 53
// module chunks = 0